module.exports = __webpack_public_path__ + "img/053.c74ae8a7.png";